import flatpickr from "flatpickr";

(function () {
    "use strict";

    $(".timepicker").each(function () {
        let options = {
            enableTime: true,
            noCalendar: true,
            dateFormat: "h:i K",
            allowInput: true,
        };

        if ($(this).data("format")) {
            options.dateFormat = $(this).data("format");
        }

        if ($(this).data("min")) {
            options.minTime = $(this).data("min");
        }

        if ($(this).data("max")) {
            options.maxTime = $(this).data("max");
        }

        if ($(this).data("hour-step")) {
            options.hourIncrement = $(this).data("hour-step");
        }

        if ($(this).data("minute-step")) {
            options.minuteIncrement = $(this).data("minute-step");
        }

        flatpickr(this, options);
    });
})();
